<component-modal [showFooter]="false" [showHeader]="false">
  <ng-container body>
    <div class="d-flex flex-column align-items-center gap-4 text-center">
      <!-- Icon -->
      <custom-icon name="checkCircle" color="var(--primary-color)" [size]="65" viewBox="0 0 65 65"></custom-icon>

      <!-- Content -->
      <div class="d-flex flex-column align-items-center gap-2">
        <h4 class="fw-bold">Thank you for your purchase!</h4>
        <p class="text-center text-muted m-0">Your subscription has been successfully activated.</p>
      </div>

      <button type="button" class="btn btn-lg btn-primary" (click)="onContinue()">Continue</button>
    </div>
  </ng-container>
</component-modal>
